import { render, staticRenderFns } from "./ForgotPasswordLayout.vue?vue&type=template&id=26d278b3&"
import script from "./ForgotPasswordLayout.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports